export default "__VITE_ASSET__BaQ0Sl2c__"